import Skeleton from '@material-ui/lab/Skeleton';
import { useStyles } from './TakisSkeleton.styles';

const TakisFreeTextSkeleton = () => {
    const classes = useStyles();
      return (
        <div className={`${classes.freeText}`}>
            <Skeleton variant="rect" className={classes.freeText_heading}/>
            <Skeleton className={classes.freeText_textLine}></Skeleton>
            <Skeleton className={classes.freeText_textLine}></Skeleton>
            <Skeleton className={classes.freeText_textLine}></Skeleton>
            <Skeleton className={classes.freeText_textLine}></Skeleton>
            <Skeleton className={classes.freeText_textLine}></Skeleton>
            <Skeleton variant="rect" className={classes.freeText_button}/>
        </div>
      );
}

export default TakisFreeTextSkeleton;
